import Head from 'next/head'
import { GetStaticProps, GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { STUDENT_PANEL_VIEW } from '~/types/student'
import { usePageTitle } from '~/utils/tags'

import PanelWrapper from '~/panels/components/PanelWrapper/PanelWrapper'
import StudentReceipts from '~/panels/student/pages/StudentReceipts/StudentReceipts.page'
import { STUDENT_PANEL_TABS } from '~/panels/constants/student-panel'
import AuthGuard from '~/components/AuthGuard'

const StudentReceiptsPage: NextPage = () => {
  const { t } = useTranslation('studentPanel')
  const title = t('title')
  const pageTitle = usePageTitle(title)

  return (
    <DefaultLayout>
      <Head>
        <title>{pageTitle}</title>
        <meta content="noindex" name="robots" />
      </Head>
      <AuthGuard>
        <PanelWrapper tabs={STUDENT_PANEL_TABS} title={title} view={STUDENT_PANEL_VIEW.RECEIPTS}>
          <StudentReceipts />
        </PanelWrapper>
      </AuthGuard>
    </DefaultLayout>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      ...COMMON_TRANSLATION_MODULE_NAMES,
      'adminPanel',
      'studentPanel',
      'booking',
      'panels',
      'errors',
      'studentInfo',
    ])),
  },
})

export default StudentReceiptsPage
